import { IStyle } from '@fluentui/react';

import { Sizes, ZIndices } from '../../themes/styles';

export interface IMessageBarListStyles {
  root?: IStyle;
  messageBar?: IStyle;
}

export const messageBarListStylesDefault: IMessageBarListStyles = {
  root: {
    marginBottom: 8,
  },
  messageBar: {
    marginTop: 8,
  },
};

export const messageBarListStylesToast: IMessageBarListStyles = {
  root: {
    position: 'absolute',
    zIndex: ZIndices.third,
    width: 512,
    top: Sizes.headerHeight,
    right: 20,
  },
};

export const messageBarListStylesNotification: IMessageBarListStyles = {
  messageBar: {
    marginTop: 0,
  },
};
